import React, { useState } from 'react';
import Header from '../components/header';
import { ImageIcon } from 'lucide-react';

export default function ImageGenerator() {
    const [showModel, setShowModel] = useState(false);
    const [speed, setSpeed] = useState("speed");
    const [standard, setStandard] = useState("standard");
    const [prompt, setPrompt] = useState("");
    const [error, setError] = useState("");
    const [image, setImage] = useState("");

    const getData = async () => {
        setImage(" ")
        if (!prompt) {
            setError("Enter Text First");
            setTimeout(() => setError(''), 2500);
            return;
        }

        setShowModel(true);
        setError("");

        try {
            const response = await fetch('https://toolisobackend.vercel.app/imageGenerator', {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ prompt })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error('Failed to generate image, Check your internet connection');
            }

            const imageData = await response.text();
            setImage(imageData);
        } catch (err) {
            console.error(err);
            setError("Failed to generate image, Check your internet connection");
        } finally {
            setShowModel(false);
        }
    };

    const downloadImage = (imageUrl) => {
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = imageUrl;
    
    // Extract the filename from the URL or use a default one
    const fileName = imageUrl.split('/').pop() || 'download';
    link.download = fileName;
    
    // Append to the body, click, and then remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

    return (
        <div>
            <Header />
            <div className="imageGenerator">
                <div className="imgGenerator">
                    <div className="firstGen">
                        <p>Create an image from text prompt</p>
                        <textarea 
                            type="text" 
                            value={prompt} 
                            onChange={(e) => setPrompt(e.target.value)} 
                            placeholder='Generate a street art style image.' 
                        />
                        {showModel ? (
                            <div className="outerspin">
                                <div className='spinner'></div>
                            </div>
                        ) : (
                            <button className='btn' onClick={getData}>Submit</button>
                        )}
                        {error && <p style={{color:"red"}}>{error}</p>}
                        
                        <p>Choose a model</p>
                        <div className="modelGenerator">
                            <div className={`HDmodel ${standard === "standard" ? 'setGenerator' : 'getGenerator'}`} 
                                 onClick={() => setStandard("standard")}>
                                Standard
                            </div>
                            <div className={`HDmodel ${standard === "hd" ? 'setGenerator' : 'getGenerator'}`} 
                                 onClick={() => setStandard("hd")}>
                                HD
                            </div>
                        </div>
                        
                        <p>Choose preference</p>
                        <div className="modelGenerator">
                            <div className={`HDmodel ${speed === "speed" ? 'setGenerator' : 'getGenerator'}`} 
                                 onClick={() => setSpeed("speed")}>
                                Speed
                            </div>
                            <div className={`HDmodel ${speed === "quality" ? 'setGenerator' : 'getGenerator'}`} 
                                 onClick={() => setSpeed("quality")}>
                                Quality
                            </div>
                        </div>
                    </div>
                    
                    <div className="secondGen">
                        {
                            image?
                            showModel?
                                    <div class="loaderImg">
                                        <div class="box1Img"></div>
                                        <div class="box2Img"></div>
                                        <div class="box3Img"></div>
                                    </div>
                            :
                            <div className="imageSecondGen">
                                <img src={image} alt="" />
                                <div className="innerBtnGen">
                                    <button className='btn' onClick={() => downloadImage(image)}>Download</button>
                                </div>
                            </div>
                            :
                            <div className="innerSecondGen">
                                <ImageIcon size={30} color='#B3B3B3'/>
                                <p>Your image display here</p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}